import { create } from 'zustand';
import { messages, type Locale, type Messages } from './messages';

const STORAGE_KEY = 'schuecal.locale';

function detectInitialLocale(): Locale {
  if (typeof window === 'undefined') return 'de';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'de' || stored === 'en') return stored;
  const nav = window.navigator?.language?.slice(0, 2).toLowerCase();
  return nav === 'en' ? 'en' : 'de';
}

type LocaleState = {
  locale: Locale;
  setLocale: (l: Locale) => void;
  toggle: () => void;
};

export const useLocale = create<LocaleState>((set, get) => ({
  locale: detectInitialLocale(),
  setLocale(l) {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, l);
    }
    set({ locale: l });
  },
  toggle() {
    const next: Locale = get().locale === 'de' ? 'en' : 'de';
    get().setLocale(next);
  },
}));

export function useT(): Messages {
  const locale = useLocale((s) => s.locale);
  return messages[locale];
}

export function format(template: string, params: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (_, key) =>
    key in params ? String(params[key]) : `{${key}}`,
  );
}

export type { Locale, Messages };
